"use client";
import clsx from "clsx";
import type { ReactNode } from "react";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  value: string;
  isVertical?: boolean;
  children?: ReactNode;
  className?: string;
  isSmall?: boolean;
};
export const Radio = <T extends FieldValues>({
  children,
  name,
  control,
  isVertical,
  className,
  value,
  isSmall,
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <label
      className={clsx(
        className,
        "flex items-center cursor-pointer min-h-[24px] min-w-[24px] relative select-none group",
        {
          "pl-0 pt-8 justify-center": isVertical,
          "pl-8": !isVertical,
          "text-primary": !error,
          "text-[#C92A2A]": error,
        },
      )}
    >
      {children}
      <input className="cursor-pointer opacity-0 absolute" type="radio" {...field} value={value} />
      <span
        className={clsx(
          "rounded-full after:rounded-full bg-transparent border  absolute after:content-[' ']  after:absolute after:bg-pr-1 group-hover:shadow-xs group-hover:shadow-primary/75",
          {
            "w-4 h-4 after:w-3 after:h-3 after:top-[1px] after:left-[1px]": isSmall,
            "h-6 w-6 after:w-[18px] after:h-[18px]  after:top-0.5 after:left-0.5": !isSmall,
            "top-0 left-1/2 -translate-x-1/2": isVertical,
            "left-0 top-1/2 -translate-y-1/2": !isVertical,
            "after:hidden border-tx-2": field.value !== value,
            "border-pr-1": !error && field.value === value,
            "border-[#C92A2A]": error,
          },
        )}
      />
    </label>
  );
};
